import { useState } from 'react';

function formatTime(ts) {
  const d = new Date(ts);
  return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
}

const STATUS_TEXT = {
  sent: '发送中',
  delivered: '已送达',
  read: '已读',
};

export default function MessageBubble({ message, isMine, onRecall }) {
  const [showMenu, setShowMenu] = useState(false);

  if (message.recalled) {
    return (
      <div className={`message-bubble ${isMine ? 'mine' : 'theirs'} recalled`}>
        <div className="message-recalled-text">消息已撤回</div>
      </div>
    );
  }

  const canRecall = isMine && (Date.now() - message.timestamp < 120000);

  return (
    <div
      className={`message-bubble ${isMine ? 'mine' : 'theirs'}`}
      onContextMenu={(e) => {
        if (canRecall) {
          e.preventDefault();
          setShowMenu(true);
        }
      }}
      onClick={() => showMenu && setShowMenu(false)}
    >
      <div className="bubble-content">{message.content}</div>
      <div className="bubble-meta">
        <span className="bubble-time">{formatTime(message.timestamp)}</span>
        {isMine && (
          <span className={`bubble-status status-${message.status}`}>
            {STATUS_TEXT[message.status]}
          </span>
        )}
      </div>
      {showMenu && (
        <div className="bubble-menu">
          <button onClick={() => { onRecall(message.id); setShowMenu(false); }}>
            撤回
          </button>
        </div>
      )}
    </div>
  );
}
